import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
let AffiliateMixin = class AffiliateMixin extends Vue {
    goToAffiliate(uuid) {
        this.$router.push({ name: 'affiliate-manager', params: { resellerUuid: uuid } });
    }
    goToNetworkDistributor(uuid) {
        this.$router.push({ name: 'reseller-mini-apps-overview', params: { resellerUuid: uuid } });
    }
    formattedPlanType(plan) {
        if (plan) {
            const plans = plan.split('_');
            for (let i = 0; i < plans.length; i++) {
                plans[i] = plans[i][0].toUpperCase() + plans[i].substr(1);
            }
            return plans.join(' - ');
        }
        return '';
    }
    buildMessengerLink(page) {
        if (page) {
            return `m.me/${page.fbPageId}`;
        }
        return '';
    }
    buildActivePageName(page) {
        if (page) {
            return page.name;
        }
        return '';
    }
    buildAffiliateInviteLog(log) {
        if (log) {
            const parsedDate = new Date(log.createdAt);
            return moment(parsedDate).format('LLL');
        }
        return '';
    }
    get resellerUuid() {
        return this.$route.params.resellerUuid;
    }
};
AffiliateMixin = __decorate([
    Component
], AffiliateMixin);
export default AffiliateMixin;
